import { useQuery } from "@tanstack/react-query";
import type { ProductChange, ProductSizeOption } from "../models/ProductChange";
import {
	getActiveProductSizes,
	getProductChanges,
} from "../repositories/ProductChangesRepository";

export const PRODUCT_CHANGES_QUERY_KEYS = {
	all: ["productChanges"] as const,
	list: () => ["productChanges", "list"] as const,
	byId: (id: number | null) => ["productChanges", "detail", id] as const,
	productSizes: ["productChanges", "productSizes"] as const,
};

export const useProductChanges = () => {
	const query = useQuery<ProductChange[], Error>({
		queryKey: PRODUCT_CHANGES_QUERY_KEYS.list(),
		queryFn: () => getProductChanges(),
	});

	return {
		productChanges: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};

export const useActiveProductSizes = () => {
	return useQuery<ProductSizeOption[], Error>({
		queryKey: PRODUCT_CHANGES_QUERY_KEYS.productSizes,
		queryFn: getActiveProductSizes,
		staleTime: 5 * 60 * 1000,
	});
};
